/* istanbul ignore file */ /* not actual functions */

import type { SG_GraphCacheTypes } from '@sg/graphql-schema';

type GraphCacheConfig = SG_GraphCacheTypes.GraphCacheConfig;

type GraphCacheKeys = GraphCacheConfig['keys'];

export const keys: GraphCacheKeys = {
  // No Identifiers
  AvailableWantedTime: () => null,
  EstimateRange: () => null,
  IngredientModification: () => null,
  IngredientModifications: () => null,
  IngredientModificationKind: () => null,
  InvalidInput: () => null,
  HasUnseenChallenges: () => null,
  Ledger: () => null,
  LedgerItem: () => null,
  Location: () => null,
  LocationSearchResult: () => null,
  Menu: () => null,
  NoValidRestaurants: () => null,
  OrderStatus: () => null,
  OrdersResponseSuccess: () => null,
  DeliveryOrderDetail: () => null,
  RestaurantHours: () => null,
  Vendor: () => null,
  CustomerPass: () => null,
  UserPointsStatus: () => null,
  ChatToken: () => null,

  Session: (data: any) => data.csrf ?? null,
  Restaurant: (data: any) => data.slug ?? data.id ?? null,
  Asset: (data: any) => data.url ?? null,
  LoyaltyProfile: (data: any) => data.customerId ?? null,
  GiftCardBalance: (data: any) => data.customerId ?? null,
  CanCancel: (data: any) => (data.orderId ? `${data.orderId}` : null),
};
